import { ContractorPackages } from "@stories/pages/Contractor/ContractorPackages/ContractorPackages";

export const PackagesView = () => {
  return <ContractorPackages />;
};
